import { ObjetKForm, requiredRule, minValueRule, combineRules } from '@siclop/kstone-vue'

function formatDateYMD(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

export class ActivityForm extends ObjetKForm {
  projectId: number = 0
  lotId?: number
  functionalityId?: number
  estimationScaleId?: number
  activityTypeId?: number
  description: string = ''
  date: string = formatDateYMD(new Date())
  hours: number = 0
  totalCost: number = 0
  employeeId: number = 0
  gitLabIssueId?: number
  gitLabMergeRequestId?: number
  isBillable: boolean = true
  notes: string = ''

  static validationRules = {
    projectId: combineRules(requiredRule('Le projet est obligatoire')),
    description: combineRules(requiredRule('La description est obligatoire')),
    date: combineRules(requiredRule('La date est obligatoire')),
    hours: combineRules(
      requiredRule('Les heures sont obligatoires'),
      minValueRule(0.01, 'Les heures doivent être supérieures à 0')
    )
  }

  constructor(data?: Partial<Omit<ActivityForm, 'date'> & { date?: string | Date }>) {
    super(data)
    if (data) {
      this.projectId = data.projectId ?? 0
      this.lotId = data.lotId
      this.functionalityId = data.functionalityId
      this.estimationScaleId = data.estimationScaleId
      this.activityTypeId = data.activityTypeId
      this.description = data.description ?? ''
      this.date = data.date
        ? (typeof data.date === 'string' ? data.date : formatDateYMD(new Date(data.date)))
        : formatDateYMD(new Date())
      this.hours = data.hours ?? 0
      this.totalCost = data.totalCost ?? 0
      this.employeeId = data.employeeId ?? 0
      this.gitLabIssueId = data.gitLabIssueId
      this.gitLabMergeRequestId = data.gitLabMergeRequestId
      this.isBillable = data.isBillable ?? true
      this.notes = data.notes ?? ''
    }
  }
}
